import React from 'react';
import { FaChalkboardTeacher, FaFileExcel, FaPaperPlane } from 'react-icons/fa';
import CopyToClipboard from '../../../core/components/CopyToClipboard';
import { apiUrl, getToken, urlWebsite } from '../../../../../config';
import userEvent from '@testing-library/user-event';
import { useAuth } from '../../../../../hooks/Auth';
import downloadit from '../../../../../utils/download';
import api from '../../../../../services/api';

interface ICreateModule {
  lineData: Record<string, any>;
}


export default function ExportList(): JSX.Element {

  const { user } = useAuth();

  const download = async () => {

    await api.get('/send-submission-to-poster')
  }

  const moduleList = (): JSX.Element => {

    return <> {user && user.profile === 1 ? <button className='searchButton'><FaPaperPlane onClick={() => download()} title="Enviar trabalhos para a área de pôsteres" /> </button> : <></>}
    </>;
  }



  return moduleList();
}
